import {CreateControllerFn} from '@wix/yoshi-flow-editor'

const createController: CreateControllerFn = async ({flowAPI, controllerConfig}) => {
  return {
    async pageReady() {},
  }
}

export default createController
